// global modal - there should only ever be one of these open at once
// if child modals are needed, those can be added at that level
import Modal from "@mui/material/Modal";
import React, { ReactElement } from "react";
import { useStoreDispatch, useStoreSelector } from "../../../store/Hooks";
import { navSliceActions } from "../../../store/slices/NavSlice";
import Box from "@mui/material/Box";
import WarningIcon from "@mui/icons-material/Warning";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import PublishIcon from "@mui/icons-material/Publish";
import Tooltip from "@mui/material/Tooltip";

const style = {
    position: "absolute",
    top: "35%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "8px solid rgb(17, 80, 142)",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    borderRadius: "20px 20px",
};


interface CareSenseAlertProps {
    id: number | null;
    type: string;
    message: string;
}

const CareSenseAlert = (props: CareSenseAlertProps) => {
    const dispatch = useStoreDispatch();
    const alertCallback = useStoreSelector(
        (state) => state.nav.modalCallback,
    );


    const handleClose = () => {
        dispatch(
            navSliceActions.closeModal(),
        );
    };

    const handleProceed = () => {
        if (alertCallback) {
            alertCallback();
        }
        dispatch(
            navSliceActions.closeModal()
        );
    };
    return (

        <Box sx={{ ...style }}>
            <h3>
                <Grid container columnSpacing={1}>
                    <Grid item xs={1}>
                        <WarningIcon color="warning" style={{ fontSize: "30pt", marginLeft: "-10px", marginTop: "20px" }} />
                    </Grid>
                    <Grid item xs={11}>

                        <div style={{ marginLeft: "20px" }}>{props.message}</div>
                    </Grid>
                </Grid>
            </h3>
            <div style={{ padding: "20px" }}>
                <Button style={{ float: "left" }} color="error" variant="outlined" onClick={handleClose}>Cancel</Button>
                {alertCallback && <Button onClick={handleProceed} style={{ float: "right" }} color="success" variant="contained">Yes, I Understand</Button>}
            </div>
        </Box>
    );
};

export default CareSenseAlert;